import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const KeyTextFocus = styled.div<React.CSSProperties>`
  position: absolute;
  width: ${36 * Screen.widthRatio}px;
  left: ${-5 * Screen.widthRatio}px;
  top: ${-46 * Screen.widthRatio}px;
  height: ${45 * Screen.widthRatio}px;
  border-radius: ${8 * Screen.widthRatio}px;
`;

export default KeyTextFocus;
